import { AssessmentRecommendationModel, AssessmentReferralModel, BlobSasModel, enums, IAssessmentRecommendationModel, IAssessmentReferralModel, IBlobSasModel, IIntakePetModel, IntakePetModel, SalesItemModel, ISalesItemModel, QuestionModel, IQuestionModel } from '@common/models';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from './serviceHelper';
import { ServiceMethodOptions } from './types';

export class StorageService {

    // #region Private Variables        
    private static baseUrl: string = '/api/';

    private static publicUserHeader: any = {
        'vpca': '351BD313-2C19-442B-BC87-C69356EB59EF',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
    };
    // #endregion

    public static tags = {
        getSas: "getSas",
        assessmentReferrals: "uploadReferralAttachment",
        uploadRecommendationAttachment: "uploadRecommendationAttachment",
        uploadHelpPhoto: "uploadHelpPhoto",
        uploadPetPoto: "uploadPetPhoto",
        uploadIntakePetPhotoPublic: "uploadIntakePetPhotoPublic",
        uploadQuestionFile: "uploadQuestionFile",
    }

    static getSas = (file: File, modelId: number, isPublic: boolean = false, containerName: enums.BlobEntityType, options?: ServiceMethodOptions): Promise<BlobSasModel> => {
        const ensureEntityExists = (modelId != 0) ? 'true' : 'false';
        const vpca = (isPublic) ? `?vpca=${this.publicUserHeader.vpca}` : '';

        return trackPromise(new Promise<BlobSasModel>((resolve, reject) => {
            // CONTAINER NAME -> Enums on AzureBlobStore. ;)
            http(`/api/storage/GetSAS/${file.name}/${containerName.toString()}/${modelId}/${ensureEntityExists}${vpca}`).get<IBlobSasModel>()
                .then((request) => {
                    ServiceHelper.showSuccess("Get Sas Successful", options);
                    resolve(new BlobSasModel(request));
                })
                .catch((err) => {
                    ServiceHelper.showError("Failed to fetch Sas Model.", options);
                    reject(err);
                });
        }), this.tags.getSas);
    };

    static uploadReferralAttachment = (sasModel: IBlobSasModel, options?: ServiceMethodOptions): Promise<AssessmentReferralModel> => {
        return trackPromise(new Promise<AssessmentReferralModel>((resolve, reject) => {
            http(`${this.baseUrl}/assessmentReferral/attachment/`).post<IAssessmentReferralModel>(sasModel)
                .then((response) => {
                    ServiceHelper.showSuccess("Upload Successful", options);
                    resolve(new AssessmentReferralModel(response));
                })
                .catch((err) => {
                    ServiceHelper.showError("Failed to upload attachment.", options);
                    reject(err);
                })
        }), this.tags.assessmentReferrals);
    }

    static uploadRecommendationAttachment = (sasModel: IBlobSasModel, options?: ServiceMethodOptions): Promise<AssessmentRecommendationModel> => {
        return trackPromise(new Promise<AssessmentRecommendationModel>((resolve, reject) => {
            http(`${this.baseUrl}/assessmentrecommendation/attachment/`).post<IAssessmentRecommendationModel>(sasModel)
                .then((response) => {
                    ServiceHelper.showSuccess("Upload Successful", options);
                    resolve(new AssessmentRecommendationModel(response));
                })
                .catch((err) => {
                    ServiceHelper.showError("Failed to upload attachment.", options);
                    reject(err);
                })
        }), this.tags.uploadRecommendationAttachment);
    }

    static uploadIntakePetPhotoPublic = (sasModel: IBlobSasModel, options?: ServiceMethodOptions): Promise<IntakePetModel> => {
        return trackPromise(new Promise<IntakePetModel>((resolve, reject) => {
            http(`${this.baseUrl}/intake/petphoto/`).mergeOptions({ headers: this.publicUserHeader }).post<IIntakePetModel>(sasModel)
                .then((response) => {
                    ServiceHelper.showSuccess("Upload Successful", options);
                    resolve(new IntakePetModel(response));
                })
                .catch((err) => {
                    ServiceHelper.showError("Failed to upload photo.", options);
                    reject(err);
                });
        }), this.tags.uploadIntakePetPhotoPublic);
    };

    static uploadQuestionFile = (sasModel: IBlobSasModel): Promise<QuestionModel> => {
        return trackPromise(new Promise<QuestionModel>((resolve, reject) => {
            http(`${this.baseUrl}/section/questionphoto/`).post<IQuestionModel>(sasModel)
                .then((request) => {
                    resolve(new QuestionModel(request));
                })
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.uploadQuestionFile)
    };

    static uploadHelpPhoto = (sasModel: IBlobSasModel): Promise<SalesItemModel> => {
        return trackPromise(new Promise<SalesItemModel>((resolve, reject) => {
            http(`${this.baseUrl}/salesItem/photo/${sasModel.modelId}`).post<ISalesItemModel>(sasModel)
                .then((response) => new SalesItemModel(response))
                .then(resolve)
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.uploadHelpPhoto);
    }

}
